 <template >
    <v-snackbar class="snack" v-model="snackbar" :timeout="-1" v-bind="$attrs" v-on="$listeners">        
        <v-icon class="iconI" v-if="$attrs.color === 'success'">mdi-check-circle</v-icon>
        <v-icon class="iconI" v-else-if="$attrs.color === 'error'">mdi-alert</v-icon>
        <v-icon class="iconI" v-else-if="$attrs.color === 'info'">mdi-information</v-icon>
        <v-icon class="iconI" v-else>mdi-exclamation</v-icon>     
        <span>{{text}}</span>
        <template v-slot:action="{ attrs }">
          <v-btn icon              
              v-bind="attrs"
              @click="snackbar = false"
            >
              <v-icon>mdi-close</v-icon>              
          </v-btn>
        </template>
    </v-snackbar>
  </template>
<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      snackbar: true,
      text: `I'm a snackbar component`,
    }
  },
  methods: {
  }

}
</script>

<style lang="css">
.snack {
    position: relative !important;
    height: auto !important;
}

.iconI {
padding-right: 10px;
}

</style>
